@file:OptIn(InternalResourceApi::class)

package waifupics.modules.features.gallery.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/waifupics.modules.features.gallery.generated.resources/"

@delegate:ResourceContentHash(-1_589_009_142)
internal val Res.drawable.ic_heart: DrawableResource by lazy {
      DrawableResource("drawable:ic_heart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_heart.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_heart", Res.drawable.ic_heart)
}
